var _circle, _path, _path2, _path3, _path4, _circle2, _circle3, _circle4, _circle5, _circle6, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgThreespecial(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 127,
    height: 126,
    viewBox: "0 0 127 126",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 63.5668,
    cy: 62.8325,
    r: 62.8325,
    fill: "url(#paint0_linear_4741_2341)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M78.7272 46.3258C67.4154 46.3258 42.9479 43.3848 42.9479 43.3848C42.9479 43.3848 38.0556 48.7664 35.2276 51.5943C29.9591 56.8628 30.4173 63.5311 29.7188 71.8481C30.5869 94.9638 45.3856 113.382 63.5722 113.382C81.6542 113.382 96.3935 95.1703 97.4087 72.2327C96.4132 61.9673 89.5017 46.3258 78.7272 46.3258Z",
    fill: "#F7DECE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M63.5737 102.069C56.9364 102.069 53.4637 98.7887 53.0904 98.4126C52.5564 97.8861 52.2534 97.169 52.2481 96.4191C52.2428 95.6692 52.5356 94.9479 53.0621 94.4138C53.5887 93.8798 54.3057 93.5768 55.0557 93.5715C55.8056 93.5662 56.5269 93.8591 57.0609 94.3856C57.2051 94.5185 59.3402 96.4132 63.5737 96.4132C67.8693 96.4132 70.0016 94.4619 70.0921 94.3799C70.6352 93.8711 71.3557 93.5949 72.0997 93.6102C72.8437 93.6256 73.5522 93.9312 74.0739 94.4619C74.5913 94.9903 74.8796 95.7012 74.8764 96.4407C74.8733 97.1802 74.5788 97.8887 74.0569 98.4126C73.6836 98.7887 70.2109 102.069 63.5737 102.069ZM66.4016 87.9293H60.7457C59.9957 87.9293 59.2764 87.6314 58.746 87.1011C58.2157 86.5707 57.9177 85.8514 57.9177 85.1014C57.9177 84.3514 58.2157 83.6321 58.746 83.1017C59.2764 82.5714 59.9957 82.2734 60.7457 82.2734H66.4016C67.1516 82.2734 67.8709 82.5714 68.4013 83.1017C68.9316 83.6321 69.2296 84.3514 69.2296 85.1014C69.2296 85.8514 68.9316 86.5707 68.4013 87.1011C67.8709 87.6314 67.1516 87.9293 66.4016 87.9293Z",
    fill: "#C1694F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M49.4334 76.6165C48.6834 76.6165 47.9641 76.3186 47.4338 75.7882C46.9034 75.2579 46.6055 74.5386 46.6055 73.7886V68.1326C46.6055 67.3826 46.9034 66.6633 47.4338 66.133C47.9641 65.6026 48.6834 65.3047 49.4334 65.3047C50.1834 65.3047 50.9027 65.6026 51.4331 66.133C51.9634 66.6633 52.2614 67.3826 52.2614 68.1326V73.7886C52.2614 74.5386 51.9634 75.2579 51.4331 75.7882C50.9027 76.3186 50.1834 76.6165 49.4334 76.6165ZM77.713 76.6165C76.963 76.6165 76.2437 76.3186 75.7133 75.7882C75.183 75.2579 74.885 74.5386 74.885 73.7886V68.1326C74.885 67.3826 75.183 66.6633 75.7133 66.133C76.2437 65.6026 76.963 65.3047 77.713 65.3047C78.463 65.3047 79.1823 65.6026 79.7126 66.133C80.243 66.6633 80.5409 67.3826 80.5409 68.1326V73.7886C80.5409 74.5386 80.243 75.2579 79.7126 75.7882C79.1823 76.3186 78.463 76.6165 77.713 76.6165Z",
    fill: "#662113"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M63.5667 23.1211C86.77 23.1211 101.266 40.2415 101.266 54.5086C101.266 68.7728 98.3646 74.4852 95.466 68.7728C92.5645 63.0688 89.6659 54.534 89.6659 54.534C89.6659 54.534 79.8302 60.9054 72.1241 51.6523C72.1241 51.6523 75.1698 68.7728 57.7665 51.6523C57.7665 51.6523 60.668 63.0688 43.2676 48.8018C43.2676 48.8018 34.566 54.5086 31.6673 68.7728C30.8642 72.7347 25.8672 68.7728 25.8672 54.5086C25.8644 40.2415 37.4646 23.1211 63.5667 23.1211Z",
    fill: "#577CFF"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 79.7236,
    cy: 87.747,
    r: 1.07713,
    fill: "#FF9494"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 81.3393,
    cy: 90.4409,
    r: 0.538564,
    fill: "#FF9494"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 79.1841,
    cy: 93.6723,
    r: 1.61569,
    fill: "#FF9494"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 84.0322,
    cy: 94.2099,
    r: 1.07713,
    fill: "#FF9494"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 86.7231,
    cy: 90.4399,
    r: 1.61569,
    fill: "#FF9494"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4741_2341",
    x1: 63.5668,
    y1: 0,
    x2: 63.5668,
    y2: 125.665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AFC1DC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E2E5ED"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThreespecial);
export default __webpack_public_path__ + "static/media/threespecial.7fd46fc49a9e98fff7c2ae2c71fc1557.svg";
export { ForwardRef as ReactComponent };